import { RowData } from '../../../../../../baseComponents/TwinTable/types'
import { CustomSelectSectionItems } from '../../../../../../forms/CustomSelect/CustomSelectSections/types'
import { ItemCustomSelectDropDownRow } from '../../../../../../forms/CustomSelect/DropDown/types'
import { TwinDictionary } from '../../../../../../utils/globals/dictionary'
import { prepareForSearch } from '../../../../../../utils/globals/search'
import { SellVariableTypeInversed } from '@teinor/erp/types/company/config/sellVariable'
import { SellVariablePayload } from '../../../../../../utils/reducers/company/sellVariable'

export const sortProductAddons = (items: any, ParentProdutId: number) => {
    let specials: ItemCustomSelectDropDownRow[] = []
    const sectionArrToSort: { [pos: number]: ItemCustomSelectDropDownRow[] } = {}
    const sectionPos: { [pos: number]: ItemCustomSelectDropDownRow } = {}
    let posSection = 0
    let arrToSort: ItemCustomSelectDropDownRow[] = []
    for (let i = 0; i < items.length; i++) {
        const element = items[i]
        const nextElement = items[i + 1]
        if (element.value === '') {
            if (nextElement?.value === '0') {
                specials.push(element)
            } else {
                posSection = i
                sectionPos[i] = element
            }
        } else if (element.value === '0' || String(element.value) === String(ParentProdutId)) {
            specials.push(element)
        } else {
            arrToSort.push(element)
        }
        if (nextElement?.value === '' || !nextElement) {
            sectionArrToSort[posSection] = arrToSort
            arrToSort = []
        }
    }
    for (const key in sectionArrToSort) {
        sectionArrToSort[key].sort((a, b) => {
            if (typeof a.text === 'string' && typeof b.text === 'string') {
                return prepareForSearch(a.text) > prepareForSearch(b.text) ? 1 : -1
            }
            return a.text > b.text ? 1 : -1
        })
        if (sectionPos?.[key]) {
            specials.splice(parseInt(key), 0, sectionPos?.[key])
        }
        specials = [...specials, ...sectionArrToSort[key]]
    }

    return specials
}

export const excludeProductAddonId = (memorizedItems: CustomSelectSectionItems, ProductAddonId: number) => {
    const result: CustomSelectSectionItems = JSON.parse(JSON.stringify(memorizedItems))
    for (const section of result) {
        if (section.childs) {
            for (const key in section.childs) {
                const element = section.childs[key]
                if (!element.ProductAddonId === undefined) {
                    break
                }
                if (String(element.ProductAddonId) === String(ProductAddonId)) {
                    delete section.childs[key]
                }
            }
        }
    }
    return result
}

export const parseSellVariables = (sellVariables: SellVariablePayload) => {
    const result: TwinDictionary = {}
    for (const key in sellVariables) {
        const variable = sellVariables[key]
        if (variable.type === SellVariableTypeInversed['number']) {
            result['var_' + key] = sellVariables[key]
        }
    }
    return result
}

export const parseScaleValue = (allRowData: RowData) => {
    if (allRowData.ScaleByProductId) {
        return allRowData.ScaleByProductId
    } else if (allRowData.ScaleByVariableId) {
        return 'var_' + allRowData.ScaleByVariableId
    }
    return 0
}